interface ColumnTitlesProps {
    translate: (key: string) => string;
    isSelectAllEnabled: boolean;
    checked: boolean;
    onSelectAllCheckPress: (checked: boolean) => void;
}

const columnTitles = ({
    translate,
    isSelectAllEnabled,
    checked,
    onSelectAllCheckPress
}: ColumnTitlesProps): any[] => [
    {
        label: '',
        showSelectAllCheck: true,
        checked,
        isSelectAllEnabled,
        onSelectAllCheckPress
    },
    translate('visits.table.columnsTitles.contractCUIT'),
    translate('visits.table.columnsTitles.contract'),
    translate('visits.table.columnsTitles.establishment'),
    translate('visits.table.columnsTitles.visitType'),
    translate('visits.table.columnsTitles.visitDate'),
    translate('visits.table.columnsTitles.stateSRT'),
    translate('visits.table.columnsTitles.generationDate'),
    translate('visits.table.columnsTitles.actions')
];

const columnWidths = ['5%', '15%', '15%', '15%', '15%', '10%', '10%', '10%', '5%'];

export { columnTitles, columnWidths };
